import { useMemo } from "react";
import { useAuth } from "@clerk/react";
import { makeApi } from "@/lib/api";

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => makeApi(getToken), [getToken]);
}

export function errMsg(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x.msg).join("; ");
  return fallback;
}

export const fmtIST = (s) =>
  s ? new Date(s).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", dateStyle: "medium", timeStyle: "short" }) + " IST" : "—";

export const FAMILY_LABEL = { UGC_NET: "UGC NET", CSIR_NET: "CSIR NET" };
export const MODE_LABEL = { quick: "Quick practice", intermediate: "Intermediate practice", full: "Full-length mock" };
